/**
 * Filters out invalid characters from the input value
 * @param value - The raw input value
 * @param allowDecimals - Whether to allow decimal separators (comma)
 * @returns Filtered string containing only valid characters
 */
export const filterInvalidCharacters = (
  value: string,
  allowDecimals: boolean,
): string => {
  // Keep only digits and decimal separator (comma) if allowed
  let filtered = value.replace(/[^\d,]/g, "");

  if (allowDecimals) {
    // Ensure only one comma is allowed
    const commaIndex = filtered.indexOf(",");
    if (commaIndex !== -1) {
      // Keep everything up to and including the first comma, then only digits
      filtered =
        filtered.substring(0, commaIndex + 1) +
        filtered.substring(commaIndex + 1).replace(/,/g, "");
    }
  } else {
    // Remove all commas if decimals are not allowed
    filtered = filtered.replace(/,/g, "");
  }

  return filtered;
};
